export default class Graph {
    // internal fields (underscore convention) — read directly by the
    // reachability and simple-path friend modules, so they stay public
    _nodeIndex = new Map<string, number>(); // string key → integer index
    _nodeKeys: string[] = [];               // integer index → string key
    _adj: number[][] = [];                  // forward adjacency: index → [index, ...]
    _radj: number[][] = [];                 // reverse adjacency: index → [index, ...]
    _size = 0;

    clear(): void {
        this._nodeIndex.clear();
        this._nodeKeys.length = 0;
        this._adj.length = 0;
        this._radj.length = 0;
        this._size = 0;
    }

    addNode(key: string): void {
        if (this._nodeIndex.has(key)) {
            throw new Error(`Graph.addNode: node "${key}" already exists in the graph.`);
        }
        const idx = this._size++;
        this._nodeIndex.set(key, idx);
        this._nodeKeys.push(key);
        this._adj.push([]);
        this._radj.push([]);
    }

    addEdge(sourceKey: string, targetKey: string): void {
        const srcIdx = this._nodeIndex.get(sourceKey);
        const tgtIdx = this._nodeIndex.get(targetKey);
        if (srcIdx === undefined) {
            throw new Error(`Graph.addEdge: source node "${sourceKey}" not found in the graph.`);
        }
        if (tgtIdx === undefined) {
            throw new Error(`Graph.addEdge: target node "${targetKey}" not found in the graph.`);
        }
        this._adj[srcIdx].push(tgtIdx);
        this._radj[tgtIdx].push(srcIdx);
    }

    hasNode(key: string): boolean {
        return this._nodeIndex.has(key);
    }

    forEachNode(callback: (key: string) => void): void {
        for (let i = 0; i < this._size; i++) {
            callback(this._nodeKeys[i]);
        }
    }
}
